import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import Authentication from "./Components/Authentication/Authentication";
import DocumentDetails from "./Components/DocumentsDetails/DocumentDetails";
import LandingPage from "./Components/LandingPage";
import LoanOfficer from "./Components/LoanOfficer/LoanOfficer";
import UserDetails from "./Components/UserDetails/UserDetails";
import ErrorPage from "./ErrorPage";
import "./index.css";
import store from "./Redux/store";
import reportWebVitals from "./reportWebVitals";

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/login",
        element: <Authentication />,
      },

      {
        path: "/user",
        element: <UserDetails />,
      },
      {
        path: "/documents",
        element: <DocumentDetails />,
      },
      {
        path: "/loan-officer",
        element: <LoanOfficer />,
      },
    ],
    errorElement: <ErrorPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ChakraProvider>
      <RouterProvider router={appRouter} />
    </ChakraProvider>
  </Provider>
);

reportWebVitals();
